import { render, staticRenderFns } from "./t-orm-item.vue?vue&type=template&id=38f6f598&lang=pug&"
import script from "./t-orm-item.vue?vue&type=script&lang=js&"
export * from "./t-orm-item.vue?vue&type=script&lang=js&"
import style0 from "./t-orm-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDivider,VSimpleCheckbox})
